import script from "./ExchangeItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExchangeItemList.vue?vue&type=script&setup=true&lang=js"

import "./ExchangeItemList.vue?vue&type=style&index=0&id=763a74ca&lang=css"

const __exports__ = script;

export default __exports__